import classNames from 'classnames';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import useStep from './useStep';

import styles from './StepSwitch.scss';

export const StepIcon = ({ as: Tag = 'li', step: { number, isCurrent, isDone, icon: Icon }, style }) => {
    const { gotoStep } = useStep();

    const handleClick = useCallback(() => gotoStep(number), [gotoStep, number]);

    return (
        <Tag
            className={classNames(styles.step, {
                [styles.done]: isDone,
                [styles.current]: isCurrent,
            })}
            style={isCurrent ? style.stepCurrent : style.step}
            onClick={handleClick}
        >
            <div className={styles.icon}>{Icon ? <Icon size={20} /> : number}</div>

            <div className={styles.mark}>{isDone && '✔'}</div>
        </Tag>
    );
};

StepIcon.propTypes = {
    as: PropTypes.elementType,
    step: PropTypes.shape({
        number: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        icon: PropTypes.elementType,
        isCurrent: PropTypes.bool,
        isDone: PropTypes.bool,
    }).isRequired,
    style: PropTypes.shape({
        step: PropTypes.object,
        stepCurrent: PropTypes.object,
    }).isRequired,
};
